/* src/app/sections/angular-section/angular-section.component.css */
/*# sourceMappingURL=angular-section.component.css.map */
